module.exports = __webpack_public_path__ + "img/album15_18.3cb4f01d.jpg";